module.exports = __webpack_public_path__ + "static/352ce5a491ad4c546675e444a046e59ccff83fdcb8c63a0c92bcd03ce54eb131-1806cda6ae65109b951a9c639e0fd4c5.jpeg";